import { messageTemplatePartialBaseModel } from './crud';

export * from './types';
export const messageTemplatePartialModelKeys =
  messageTemplatePartialBaseModel.keys;

export const useMessageTemplatePartialById =
  messageTemplatePartialBaseModel.fetchById();
export const useMessageTemplatePartialByIds =
  messageTemplatePartialBaseModel.fetchByIds();
export const useMessageTemplatePartialMany =
  messageTemplatePartialBaseModel.fetchMany();
export const useMessageTemplatePartialCount =
  messageTemplatePartialBaseModel.count();
export const useMessageTemplatePartialManyInfiniteQuery =
  messageTemplatePartialBaseModel.fetchPaginated();
export const useMessageTemplatePartialUpdateOne =
  messageTemplatePartialBaseModel.edit();
export const useMessageTemplatePartialCreateOne =
  messageTemplatePartialBaseModel.create();
export const useMessageTemplatePartialRemoveOne =
  messageTemplatePartialBaseModel.delete();
export const useMessageTemplatePartialRemoveByIds =
  messageTemplatePartialBaseModel.deleteByIds();

export const useMessageTemplatePartialByIdV2 =
  messageTemplatePartialBaseModel.fetchByIdV2();
export const useMessageTemplatePartialByIdsV2 =
  messageTemplatePartialBaseModel.fetchByIdsV2();
export const useMessageTemplatePartialCountV2 =
  messageTemplatePartialBaseModel.countV2();
export const useMessageTemplatePartialManyInfiniteQueryV2 =
  messageTemplatePartialBaseModel.fetchPaginatedV2();
export const useMessageTemplatePartialUpdateOneV2 =
  messageTemplatePartialBaseModel.editV2();
export const useMessageTemplatePartialCreateOneV2 =
  messageTemplatePartialBaseModel.createV2();
export const useMessageTemplatePartialRemoveOneV2 =
  messageTemplatePartialBaseModel.deleteV2();
export const useMessageTemplatePartialRemoveByIdsV2 =
  messageTemplatePartialBaseModel.deleteByIdsV2();

export const useMessageTemplatePartialPagination =
  messageTemplatePartialBaseModel.fetchPaginated();
export const useMessageTemplatePartialPaginationV2 =
  messageTemplatePartialBaseModel.fetchPaginatedV2();
